// Core
import React from 'react';

function Icon(): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="arrow-right-icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3178 5.28743L16.8858 0.855469V3.46516H0.399902V7.10969H16.8858V9.71939L21.3178 5.28743Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Icon;
